import { QueuedIntakeFileInfo, UploadData } from '../../../store/uploadStore';
import { createCanceledError } from '../../../errors/createCanceledError';

export const validateNonImage = (file: QueuedIntakeFileInfo, upload: UploadData) => {
  // There is no validation for non-image files (lidar data), still we will simulate a short delay so that we don't
  // block the main thread for too long and the validation progress doesn't just jump to the middle.
  // Plus it will look like we are actually doing something in the UI.
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (upload.meta.abortController.signal.aborted) {
        reject(createCanceledError());
      }

      file.validation = {};
      file.isBeingValidated = false;

      resolve(file);
    }, 30);
  });
};
